/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import {
  Converter,
  ConverterService,
  Occ,
  OrderApprovalPermissionType,
} from '@lm-nx-frontend/lm-inf-core';
import {PERMISSION_TYPE_NORMALIZER} from "../../core/connectors";

@Injectable({
  providedIn: 'root',
})
export class OccPermissionTypeListNormalizer
  implements
    Converter<
      Occ.OrderApprovalPermissionTypeList,
      OrderApprovalPermissionType[]
    >
{
  constructor(private converter: ConverterService) {}

  convert(
    source: Occ.OrderApprovalPermissionTypeList,
    target?: OrderApprovalPermissionType[]
  ): OrderApprovalPermissionType[] {
    target = source.orderApprovalPermissionTypes?.map((permissionType) =>
      this.converter.convert(permissionType, PERMISSION_TYPE_NORMALIZER)
    );

    return target ?? [];
  }
}
